import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/go")({
  beforeLoad: () => {
    throw redirect({ to: "/en", statusCode: 301 });
  },
});
